import { ProfileShortInfo } from './profile-short-info';
import { ProfileLinks } from './profile-links';
import LogoutButton from './logout-button';
import { Pressable, View } from 'react-native';
import { useNavigation } from 'app/hooks/navigation';

export function SideMenuProfile() {
  const navigation = useNavigation();
  return (
    <>
      <Pressable
        onPress={() => {
          navigation.navigate('profile-overview', undefined, { pop: true });
        }}
      >
        <ProfileShortInfo />
      </Pressable>
      <ProfileLinks />
      <LogoutButton />
      <View style={{ height: 32 }} />
    </>
  );
}
